import { Directive, TemplateRef } from '@angular/core';

@Directive()
export class TemplateRefDirective {
    constructor(public readonly template: TemplateRef<HTMLElement>) {
    }
}
